<template>
  <div class="tan px_kcadd">
    <div class="px_add_con">
      <div class="h370 rdiv">
        <h3>选择附件</h3>
        <a href="javascript:vouid(0);" class="close" @click="$emit('close')"></a>
        <div class="h295">
          <table width="710" border="0" cellspacing="0" cellpadding="0">
            <thead>
            <tr>
              <td wuidth="15%"><input type='checkbox' :checked="(selected.length === data.length) && data.length != 0" @click='checkedAll()'></td>
              <td wuidth="85%">附件名称</td>
            </tr>
            </thead>
            <tbody>
            <tr v-for="item in data" :key="item.uid">
              <td>
                <input type="checkbox" :value="item.uid" :checked="selected.indexOf(item.uid)>=0" @click='checkedOne(item.uid)' />
              </td>
              <td>{{item.name}}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="w240 wrap">
        <input name="" type="button" value="确定" class="all_btn" @click="setSelected" />
        <input name="" type="button" value="取消" @click="$emit('close')" class="all_btn color_hui" />
      </div>
    </div>
  </div>
</template>
<script>
  import clonedeep from 'lodash.clonedeep'
  import Bus from '@/utils/bus'
  export default {
    props: ['list', 'idx'],
    created () {
      if (this.idx) {
        this.selected = [this.idx]
      }
    },
    data () {
      return {
        data: clonedeep(this.list),
        selected: []
      }
    },
    methods: {
      checkedOne (uid) {
        let uidIndex = this.selected.indexOf(uid)
        if (uidIndex >= 0) {
          this.selected.splice(uidIndex, 1)
        } else {
          this.selected.push(uid)
        }
      },
      checkedAll () {
        this.isCheckedAll = !this.isCheckedAll
        if (this.isCheckedAll) {
          this.selected = []
          if (this.data.length>0) {
            for (var i = 0; i<this.data.length; i++) {
              this.selected.push(this.data[i].uid)
            }
          }
        } else {
          this.selected = []
        }
      },
      setSelected () {
        if (this.selected.length > 1) {
          this.$toasted.show('只能选择一个附件')
        } else {
          Bus.$emit('set-selected-file', this.selected)
          this.$emit('close')
        }
      }
    }
  }
</script>
<style scoped>
  input[type=checkbox] {
    opacity: 1;
  }
</style>



// WEBPACK FOOTER //
// src/page/byl/org/repo/file-select.vue